<template>
  <div id="header">
    <p class='c3'>
      <span class='c2'>SAEB - Secretaria da Administra&ccedil;&atilde;o do Estado da Bahia</span>
    </p>
    <p class='c3'>
      <span class='c2'>Fale Conosco: (71) 3115-3131</span>
    </p>
    <p class='c3'>
      <span class='c2'>Endere&ccedil;o: 2&ordf; Avenida, 200, CAB - CEP: 41.745-003 </span>
    </p>
    <p class='c3'>
      <span class='c2'>Hor&aacute;rio: Segunda &agrave; Sexta</span>
    </p>
    <p class='c3'>
      <span class='c2'>08h30 &agrave;s 12h00 e de 13h30 as 18h00h</span>
    </p>
  </div>
</template>

<script>


export default {
  name: "rodape-impressao",
  components: { /*Componentes utilizados*/
  },
  props: {//Propriedades que o objeto recebe como parametro

  },
  data() {//Declaracao de variaveis
    return {

    };
  },
  created() /*Metodo de start do componente*/{

  },
  methods: {//Declaracao de todos os metodos
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.c3{line-height:0.1;orphans:2;widows:2;text-align:center}
.c2{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:'Arial';font-style:normal}
</style>


